import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './FieldSummaryPreview.css';
import PreviewCard from '../../../components/cards/cardAndPreview/PreviewCard';
import { reqFarmDetails } from '../../../actions/farmActions';

export class FieldSummaryPreview extends Component {
  componentDidMount() {
    const {
      hasFarmDetailsFetched,
      farmUuid,
      reqFarmDetails: reqFarmDetailsProp,
    } = this.props;
    if (!hasFarmDetailsFetched) {
      reqFarmDetailsProp(farmUuid);
    }
  }

  render() {
    const { farmDetails, hasFarmDetailsFetched } = this.props;
    return (
      <PreviewCard
        isLoading={!hasFarmDetailsFetched}
        testId="dmb-field-summary"
      >
        <div className={styles.details} data-test-id="field-summary-details">
          {farmDetails.growerName || '---'}
          <span className={styles.dot} />
          {farmDetails.name || '---'}
        </div>
      </PreviewCard>
    );
  }
}

FieldSummaryPreview.propTypes = {
  farmDetails: PropTypes.object.isRequired,
  farmUuid: PropTypes.string.isRequired,
  hasFarmDetailsFetched: PropTypes.bool.isRequired,
  reqFarmDetails: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { uuid, ...details } = state.farm;
  return {
    farmUuid: uuid,
    farmDetails: details,
    hasFarmDetailsFetched: Boolean(Object.keys(details).length),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      reqFarmDetails,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FieldSummaryPreview);
